import React from 'react';

/**
 * Saudi Riyal Symbol (new official 2024 symbol).
 * Renders as an inline image so it works in any text context.
 * Use `size` prop to control height (default: 1em to match surrounding text).
 */
export default function SAR({ size, className = '', style = {}, alt = 'SAR' }) {
  const h = size || '1em';
  return (
    <img
      src="/sar-symbol.png"
      alt={alt}
      data-testid="sar-symbol"
      className={`inline-block align-[-0.12em] mx-[0.15em] ${className}`}
      style={{ height: h, width: 'auto', ...style }}
      draggable={false}
    />
  );
}
